module.exports = __webpack_public_path__ + "img/zvoove_icon.d044624f.svg";